import React, { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import DatePicker from "react-modern-calendar-datepicker";
import { useDispatch, useSelector } from "react-redux";
import CustomButton from "../../../../components/CustomButton";
import LargeModal from "../../../../components/modals/LargeModal";
import {
  sampling_default_data,
  sampling_times,
} from "../../../../config/sampling";
import { closeLabOrderSamplingModal } from "../../../../redux/actions/modals";
import { addSamplingData } from "../../../../redux/actions/orders";
import toaster from "../../../../utils/toaster";

const LabOrderSamplingComponent = (props) => {
  const dispatch = useDispatch();
  const [selectedDay, setSelectedDay] = useState(null);
  const [selectedResultDay, setSelectedResultDay] = useState(null);
  const [samplingData, setSamplingData] = useState({});
  const [sampleType, setSampleType] = useState({
    blood: false,
    urine: false,
    stool: false,
  });
  const { sampling_lab_order_open, sampling_lab_order } = useSelector(
    (state) => state.modals
  );
  const { add_sampling_data_waiting } = useSelector((state) => state.orders);
  useEffect(() => {
    setSamplingData(sampling_default_data);
  }, []);
  const updateSamplingData = (key, value) => {
    let current = samplingData;
    current[key]["value"] = value;
    let sample_type = "";
    if (sampleType.blood) {
      sample_type += " (خون) ";
    }
    if (sampleType.urine) {
      sample_type += " (ادرار) ";
    }
    if (sampleType.stool) {
      sample_type += " (مدفوع) ";
    }
    current["sample_type"]["value"] = sample_type;
    setSamplingData(current);
  };
  const submitSamplingData = () => {
    if (samplingData.sampling_date.value.trim() === "") {
      toaster.error("تعیین تاریخ نمونه‌گیری الزامی است", { draggable: true });
      return;
    }
    if (samplingData.sampling_from_hour.value.trim() === "") {
      toaster.error("تعیین بازه نمونه‌گیری الزامی است");
      return;
    }

    if (
      samplingData.sampler_name.value.trim() === "" &&
      (sampling_lab_order.is_om === undefined || !sampling_lab_order.is_om)
    ) {
      toaster.error("تعیین نام نمونه‌گیر الزامی است");
      return;
    }

    if (
      samplingData.sampler_contact_phone.value.trim() === "" &&
      (sampling_lab_order.is_om === undefined || !sampling_lab_order.is_om)
    ) {
      toaster.error("تعیین شماره هماهنگی نمونه‌گیر الزامی است");
      return;
    }

    let body = {
      id: sampling_lab_order.id,
      data: samplingData,
    };
    dispatch(addSamplingData(body));
  };
  return (
    <LargeModal
      header="تعیین زمان نمونه‌گیری"
      show={sampling_lab_order_open}
      closeFunction={closeLabOrderSamplingModal}
    >
      <div className="lab-sampling-form-holder">
        <div className="form-holder">
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">
              تاریخ نمونه گیری‌ :
            </label>
            <div className="col-sm-10">
              <DatePicker
                value={selectedDay}
                onChange={(data) => {
                  setSelectedDay(data);
                  updateSamplingData(
                    "sampling_date",
                    data.year + "/" + data.month + "/" + data.day
                  );
                }}
                inputPlaceholder="تعیین زمان نمونه‌گیری"
                shouldHighlightWeekends
                locale="fa"
                style={{ width: "100%" }}
                id="sampling-date"
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">بازه زمانی : </label>
            <div className="col-sm-5">
              <select
                className="form-control"
                onChange={(sampling_from_hour) => {
                  updateSamplingData(
                    "sampling_from_hour",
                    sampling_from_hour.target.value
                  );
                }}
              >
                <option value="">از ساعت</option>
                {sampling_times.map((value, index) => {
                  return (
                    <option key={index} value={value.value}>
                      {value.title}
                    </option>
                  );
                })}
              </select>
            </div>
            <div className="col-sm-5">
              <select
                className="form-control"
                onChange={(sampling_to_hour) => {
                  updateSamplingData(
                    "sampling_to_hour",
                    sampling_to_hour.target.value
                  );
                }}
              >
                <option value="">تا ساعت</option>
                {sampling_times.map((value, index) => {
                  return (
                    <option key={index} value={value.value}>
                      {value.title}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">نام نمونه‌گیر :</label>
            <div className="col-sm-10">
              <input
                type="text"
                className="form-control"
                placeholder="مثال : اصغر محمدی"
                onChange={(sampler_name) => {
                  updateSamplingData("sampler_name", sampler_name.target.value);
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">
              موبایل نمونه‌گیر :
            </label>
            <div className="col-sm-10">
              <input
                type="text"
                className="form-control"
                placeholder="مثال : ۰۹۱۲۳۴۵۶۷۸۹"
                onChange={(sampler_contact_phone) => {
                  updateSamplingData(
                    "sampler_contact_phone",
                    sampler_contact_phone.target.value
                  );
                }}
              />
              <small className="text-muted">
                شماره نمومه‌گیر برای کاربر ارسال می‌شود. همچنین لوکیشن, آدرس و
                نوع آزمایش برای نمونه گیر پیامک می‌شود.
              </small>
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">نیاز به ناشتایی :</label>
            <div className="mb-3 margin-top-5">
              <Form.Check
                inline
                label="دارد"
                type="radio"
                name="fasting"
                onChange={(fasting) => {
                  updateSamplingData("fasting", "دارد");
                }}
              />
              <Form.Check
                inline
                label="ندارد"
                type="radio"
                name="fasting"
                onChange={(fasting) => {
                  updateSamplingData("fasting", "ندارد");
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-2 col-form-label">نوع نمونه : </label>
            <div className="mb-3 margin-top-5">
              <Form.Check
                inline
                label="خون"
                type="checkbox"
                name="test_type"
                onChange={(blood) => {
                  setSampleType((prevState) => ({
                    ...prevState,
                    blood: !sampleType.blood,
                  }));
                }}
              />
              <Form.Check
                inline
                label="ادرار"
                type="checkbox"
                name="test_type"
                onChange={(urine) => {
                  setSampleType((prevState) => ({
                    ...prevState,
                    urine: !sampleType.urine,
                  }));
                }}
              />
              <Form.Check
                inline
                label="مدفوع"
                type="checkbox"
                name="test_type"
                onChange={(stool) => {
                  setSampleType((prevState) => ({
                    ...prevState,
                    stool: !sampleType.stool,
                  }));
                }}
              />
            </div>
          </div>
          <div className="form-group row">
            <label className="col-sm-12 col-form-label">
              زمان تقریبی آماده شدن نتیجه :
            </label>
            <div className="col-sm-2"></div>
            <div className="col-sm-5">
              <DatePicker
                value={selectedResultDay}
                inputPlaceholder="انتخاب تاریخ"
                shouldHighlightWeekends
                locale="fa"
                id="result-date"
                onChange={(data) => {
                  setSelectedResultDay(data);
                  updateSamplingData(
                    "result_date",
                    data.year + "/" + data.month + "/" + data.day
                  );
                }}
              />
            </div>
            <div className="col-sm-5">
              <select
                className="form-control"
                onChange={(result_hour) => {
                  updateSamplingData("result_hour", result_hour.target.value);
                }}
              >
                <option value="">ساعت</option>
                {sampling_times.map((value, index) => {
                  return (
                    <option key={index} value={value.value}>
                      {value.title}
                    </option>
                  );
                })}
              </select>
            </div>
          </div>
          <div className="form-group row sampling-order-action-buttons">
            <div className="col-sm-2"></div>
            <div className="col-sm-5">
              <CustomButton
                className="btn btn-small btn-success text-white full-width"
                action={submitSamplingData}
                content={"تایید و ارسال"}
                block={true}
                type={"success"}
                loading={add_sampling_data_waiting}
                textWhite={true}
              />
            </div>
            <div className="col-sm-5">
              <button
                className="btn btn-small btn-outline-black full-width"
                onClick={() => {
                  dispatch(closeLabOrderSamplingModal());
                }}
              >
                انصراف
              </button>
            </div>
          </div>
        </div>
      </div>
    </LargeModal>
  );
};

export default LabOrderSamplingComponent;
